import React from "react";

import {
  computeCarbonProgramImpact,
  isSingleFieldOutcomes,
  useCurrentYearlyDataYear,
  useGetAllCarbonProgramOutcomesAdmin,
  useInventoryImpactAdmin,
} from "utils";

import { CURRENCY_CODE } from "consts";

import { ACCOUNTING_METHODOLOGY, CarbonProgram, SingleFieldOutcomes } from "models";

import { PaymentRange, ProgressBar } from "components";

export const FarmPayout = ({ fieldIds, farmId, carbonProgram }: { fieldIds: string[]; farmId: string; carbonProgram?: CarbonProgram }) => {
  const { data: carbonProgramOutcomes, progress } = useGetAllCarbonProgramOutcomesAdmin(fieldIds);
  // TODO: possibly adjust depending on the year logic we want going forward
  const { year } = useCurrentYearlyDataYear(farmId);

  // We need to filter for all the data which include fieldOutcomes (not fully sure why, following the pattern in the user app here)
  const filteredFieldOutcomes: SingleFieldOutcomes[] = Object.values(carbonProgramOutcomes ?? {}).filter(isSingleFieldOutcomes);

  // This hook is only needed if the program is inventory
  const { totalPayoutMin: totalMinInventory, totalPayoutMax: totalMaxInventory } = useInventoryImpactAdmin(year, filteredFieldOutcomes, farmId, carbonProgram);

  // We need to use different functions/hooks to calculate payout sum for inventory vs intervention
  const { totalPayoutAvg: totalIntervention } = carbonProgramOutcomes ? computeCarbonProgramImpact(carbonProgramOutcomes, year) : { totalPayoutAvg: 0 };

  // We just set the intervention payout to the same for min and max and let PaymentRange handle it
  const { min, max } =
    carbonProgram?.accountingMethodology === ACCOUNTING_METHODOLOGY.intervention
      ? { min: totalIntervention, max: totalIntervention }
      : { min: totalMinInventory, max: totalMaxInventory };

  return (
    <>
      {progress === 100 ? (
        <PaymentRange currency={carbonProgram?.currency ?? CURRENCY_CODE.EUR} min={min} max={max} size="large" />
      ) : (
        <ProgressBar percent={progress} />
      )}
    </>
  );
};
